export const LOGO = "/brand/logo.png";

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/shop-services", label: "Shop & Services" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact-ordering", label: "Contact & Ordering" },
];

const u = (id) => `https://images.unsplash.com/${id}?w=1000&q=80`;

export const IMAGES = {
  hero: "/work/pisces-sweatshirt.jpg",
  heroAlt: u("photo-1542044801-30d3e45ae49a"),
  about: u("photo-1557462987-dd1c191266f0"),
};

export const SERVICES = [
  {
    slug: "embroidery",
    title: "Custom Embroidery",
    script: "Embroidery",
    blurb: "Stitched-to-last names, logos and monograms on the pieces you love most.",
    items: ["Hats", "Graduation stoles", "Baby announcements", "Yard signs", "Sweatshirts", "Jackets"],
    image: "/work/lpn-nurse-sweatshirt.jpg",
  },
  {
    slug: "tees",
    title: "Custom T-Shirts & Apparel",
    script: "Apparel",
    blurb: "Birthday crews, family reunions, small business merch: tees made just for your moment.",
    items: ["T-shirts", "Hoodies", "Family & event shirts", "Business merch"],
    image: "/work/usm-gold-sweatshirt.jpg",
  },
  {
    slug: "spirit",
    title: "School Spirit & Team Apparel",
    script: "Spirit",
    blurb: "Show up loud for game day with matching gear for players, parents and fans.",
    items: ["Team shirts", "Spirit wear", "Booster club gear", "Coach apparel"],
    image: "/work/usm-smtt-sweatshirt.jpg",
  },
  {
    slug: "seasonal",
    title: "Seasonal & Awareness Designs",
    script: "Seasonal",
    blurb: "Holiday sets, awareness month tees and limited seasonal drops.",
    items: ["Holiday designs", "Awareness month apparel", "Back-to-school", "Seasonal drops"],
    image: u("photo-1542044801-30d3e45ae49a"),
  },
  {
    slug: "bulk",
    title: "Special & Bulk Orders",
    script: "Bulk",
    blurb: "Schools, churches, teams, businesses and event planners: we handle quantity with care.",
    items: ["Group & event orders", "Corporate apparel", "Graduation packages", "Graduation yard signs", "Custom requests"],
    image: "/work/yard-sign-jsu-2025.jpg",
  },
];

export const PRODUCT_TYPES = [
  "Hat", "Graduation stole", "Baby announcement", "Yard sign", "Sweatshirt / Hoodie", "Jacket",
  "T-shirt", "School spirit / Team apparel", "Seasonal / Awareness design", "Bulk / Special order", "Other",
];

export const stepsFor = (payments) => [
  { title: "Request", text: "Send your custom order request with your idea, sizes and inspiration photos." },
  { title: "Quote", text: "We reach out by phone, text or email with pricing and details." },
  { title: "Payment", text: `Pay securely with the Pay Now link (card or Apple Pay), or with ${payments.join(", ")}. Your order is confirmed once payment is received.` },
  { title: "Production", text: "Your order is designed and stitched with love, every single stitch." },
  { title: "Pickup / Delivery", text: "We'll arrange pickup or delivery once your order is ready." },
];
